module.exports = __webpack_public_path__ + "static/media/tron-bot.f111d06a.png";